import { render, staticRenderFns } from "./DailyBonus.vue?vue&type=template&id=62ec36d5&scoped=true"
import script from "./DailyBonus.vue?vue&type=script&lang=js"
export * from "./DailyBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec36d5",
  null
  
)

export default component.exports